// extracted by mini-css-extract-plugin
export default {"container":"license_container__IdOxm","h3":"license_h3__4ubMR","p":"license_p__cZixl","blok":"license_blok__EnuQp","img":"license_img__S5CI5"};